import React from 'react';
import { BaseButton } from '@components/BaseButton/BaseButton';
import { BlockReleaseDecorated } from '@data/blockReleases/types/BlockRelease.types';
import { ROUTE_CONSTANTS } from '@utilities/RouteConstants';
import { useHistory } from 'react-router-dom';
import {
	useBlockReleaseRequestContext
} from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestContext/BlockReleaseRequestContext';

interface NextSurgeonButtonProps {
	className?: string;
	nextRelease: BlockReleaseDecorated;
}

export const NextSurgeonButton: React.FC<NextSurgeonButtonProps> = ({
	className,
	nextRelease
}) => {
	const history = useHistory();
	const { setSelectedSurgeonFilter } = useBlockReleaseRequestContext();
	const { id, npis } = nextRelease;
	const route = `${ROUTE_CONSTANTS.BLOCK_RELEASE_RECOMMENDATION_LIST}/${id}`;
	const nudgeQueryParam = new URLSearchParams({ surgeon: npis[0].toString() }).toString();
	const handleClick = () => {
		setSelectedSurgeonFilter(npis[0].toString());
		history.replace(`${route}?${nudgeQueryParam}`);
	};

	return (
		<BaseButton
			className={className}
			dataField="blockReleaseRequestPage-blockReleaseNudgeCaughtUpMessage-nextSurgeonButton"
			onClick={handleClick}
			color="primary"
			variant="contained"
		>
			NEXT SURGEON
		</BaseButton>
	);
};
